var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1036",
    transform: "translate(74.6 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_491",
    className: "st0",
    d: "M155,322.4c46.7-76.3,129.6-122.9,219.2-122.9c89.6,0.4,172.5,46.7,219.2,122.9h228V211.1 c0-116.3-94.2-210.9-210.9-210.9H136.3C20,0.2-74.6,94.4-74.6,211.1v111.7H155V322.4z M579.3,127.3c0-20,16.3-35.8,35.8-35.8l0,0 H696c20,0,35.8,16.3,35.8,35.8l0,0v81.3c0,20-16.3,35.8-35.8,35.8h-80.8c-20,0-35.8-16.3-35.8-35.8l0,0v-81.3H579.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_492",
    className: "st0",
    d: "M632.6,457.8c0,142.5-115.9,258.4-258.4,258.4S115.9,600.3,115.9,457.8 c0.4-28.3,5.4-56.3,14.6-82.9h-205V685c0,116.3,94.2,210.9,210.9,210.9l0,0h474.3c116.3,0,210.9-94.2,210.9-210.9l0,0V375.3H618 C627.2,401.5,632.2,429.9,632.6,457.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_493",
    className: "st0",
    d: "M443.8,322.4c-21.7-11.3-45.4-17.5-69.6-17.5s-48.3,6.3-69.6,17.5 c-23.8,12.1-44.2,30.4-58.8,52.5c-16.3,24.6-24.6,53.3-24.6,82.9c0,84.6,68.8,152.9,152.9,152.9c84.6,0,152.9-68.3,152.9-152.9 c0-29.2-8.8-57.9-24.6-82.9C488,352.8,467.6,334.4,443.8,322.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c3ac72e59d19bc3e6737e1ffedcc228b.svg";
export { ForwardRef as ReactComponent };